import { Redirect } from 'expo-router';
import * as React from 'react';
import { isNonMobileWeb } from 'smoothie';

import GuideMessaging from '../../../guideMessaging/components/GuideMessaging';
import { NonMobileGuideMessagingHref } from '../../../guideMessaging/components/GuideMessagingModal';

export default function GuideMessagingScreen() {
    return isNonMobileWeb ? (
        <Redirect href={NonMobileGuideMessagingHref} />
    ) : (
        <GuideMessaging />
    );
}
